(() => {
	if (customElements.get('feature-tabs')) return;

	customElements.define('feature-tabs', class FeatureTabs extends HTMLElement {
		connectedCallback() {
			this.navItems = [...this.querySelectorAll('.js-ftabs-nav-item')];
			this.panels = [...this.querySelectorAll('.js-ftabs-panel')];

			this.navItems.forEach(item => {
				item.addEventListener('click', () => this.select(item.dataset.index));
			});
		}

		select = (index) => {
			this.navItems.forEach(item => {
				const active = item.dataset.index === index;
				item.classList.toggle('is-active', active);
				item.setAttribute('aria-selected', active);
			});
			this.panels.forEach(panel => {
				panel.classList.toggle('is-active', panel.dataset.index === index);
			});
		};
	});
})();
